import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { GradientIcon } from 'site-modules/shared/components/inventory/ev-insights/components/gradient-icon/gradient-icon';

import './cost-to-drive-insight.scss';

const COST_ICON_BY_ENGINE_TYPE_MAP = {
  electric: 'icon-power2',
  'plug-in hybrid': 'icon-power2',
  hybrid: 'icon-hybrid_mpg',
  default: 'icon-gas',
};

function CostToDriveInsightUI({ fuelCostsData = null, stateName = null, model = null }) {
  const engineType = get(fuelCostsData, 'vehicleData.engineType');
  const costPerMonth = get(fuelCostsData, 'fuelCosts.costPerMonth', 0);
  const avgCostPerMonth = get(fuelCostsData, 'statistics.byBodyTypeAndSize.combustionEngines.averageCostPerMonth', 0);
  const averageCategory = get(fuelCostsData, 'vehicleData.primaryBodyType', '');

  return (
    <div className="cost-to-drive-insight">
      <Row className={classnames('pos-r mb-1_5')}>
        <Col xs={6} className="text-center">
          <GradientIcon
            icon={COST_ICON_BY_ENGINE_TYPE_MAP[engineType] || COST_ICON_BY_ENGINE_TYPE_MAP.default}
            iconClassName="size-24"
          />

          <div className="size-24 text-cool-gray-30 fw-bold mt-0_25">
            {getPriceString(costPerMonth)}
            <span className="medium text-cool-gray-40 fw-normal">&nbsp;/mo</span>
          </div>
          <div className="medium text-cool-gray-40 mt-0_25">{model}</div>
        </Col>
        {!!avgCostPerMonth && (
          <Fragment>
            <div className="vs-separator pos-a center-x h-100 p-0 m-0 w-auto">
              <div className="pos-a center-xy bg-white medium text-cool-gray-50 py-0_25">vs.</div>
            </div>
            <Col xs={6} className="text-center">
              <GradientIcon
                icon={COST_ICON_BY_ENGINE_TYPE_MAP.default}
                iconClassName="size-24 text-cool-gray-50 mb-0_5"
              />

              <div className="size-24 text-cool-gray-50 fw-bold  mt-0_25">
                {getPriceString(avgCostPerMonth)}
                <span className="medium text-cool-gray-40 fw-normal">&nbsp;/mo</span>
              </div>
              <div className="medium text-cool-gray-40 mt-0_25">{averageCategory || 'Similar'} Avg.</div>
            </Col>
          </Fragment>
        )}
      </Row>
      <div className="medium text-cool-gray-40 mt-1_5">Monthly fuel estimates based on costs in {stateName}</div>
    </div>
  );
}

CostToDriveInsightUI.propTypes = {
  fuelCostsData: VehicleEntities.StyleFuelCostData,
  stateName: PropTypes.string,
  model: PropTypes.string,
};

export const CostToDriveInsight = React.memo(CostToDriveInsightUI);
